var map = {
	"./070---BatDasher.json": 22667,
	"./071---BatKamikaze.json": 18488,
	"./072---GoldenBatKamikaze.json": 43439,
	"./073---Fly.json": 68848,
	"./074---S_Fly.json": 60302,
	"./075---S_ZombieFly.json": 79328,
	"./076---Skull.json": 6489,
	"./077---Demon.json": 63866,
	"./078---Librarian.json": 16700,
	"./079---FlyingCrow.json": 20176,
	"./080---BatDasherPurple.json": 1085,
	"./081---Harpy.json": 50205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5199;